import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/core';

// apicore
import { APICore, setAuthorization } from 'src/helpers/api/apiCore';

// api
import {
    creatPanelCategory as createPanelCategoryApi,
    updatePanelCategory as updatePanelCategoryApi,
    getAllPanelCategory as getAllPanelCategoryApi,
    getPanelCategory as getPanelCategoryApi,
} from './api';

// actions
import { panelCategoryApiResponseSuccess, panelCategoryApiResponseError } from './actions';

// constants
import { PanelCategoryActionTypes } from './constants';

type PanelCategoryData = {
    payload: any;
    type: string;
};

const api = new APICore();

/**
 * Add Panel Category
 * @param {*} payload
 */
function* AddPanelCategory({ payload, type }: PanelCategoryData): SagaIterator {
    try {
        const response = yield call(createPanelCategoryApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                panelCategoryApiResponseSuccess(
                    PanelCategoryActionTypes.ADD_PANEL_CATEGORY,
                    data,
                    'Panel Category has been created.',
                    code,
                    false,
                    true
                )
            );
        } else {
            let msg = `An error while creating Panel Category!`;
            if (message) msg = message;
            yield put(
                panelCategoryApiResponseSuccess(
                    PanelCategoryActionTypes.ADD_PANEL_CATEGORY,
                    data,
                    msg,
                    code,
                    true,
                    false
                )
            );
        }
    } catch (error: any) {
        yield put(
            panelCategoryApiResponseError(PanelCategoryActionTypes.ADD_PANEL_CATEGORY, [], error, 404, true, false)
        );
    }
}

/**
 * Edit Panel Category
 * @param {*} payload
 */
function* EditPanelCategory({ payload, type }: PanelCategoryData): SagaIterator {
    try {
        const response = yield call(updatePanelCategoryApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                panelCategoryApiResponseSuccess(
                    PanelCategoryActionTypes.EDIT_PANEL_CATEGORY,
                    data,
                    'Panel Category has been updated.',
                    code,
                    false,
                    true
                )
            );
        } else {
            let msg = `An error while edit Panel Category!`;
            if (message) msg = message;
            yield put(
                panelCategoryApiResponseSuccess(
                    PanelCategoryActionTypes.EDIT_PANEL_CATEGORY,
                    data,
                    msg,
                    code,
                    true,
                    false
                )
            );
        }
    } catch (error: any) {
        yield put(
            panelCategoryApiResponseError(PanelCategoryActionTypes.EDIT_PANEL_CATEGORY, [], error, 404, true, false)
        );
    }
}

/**
 * Fetch Panel Category
 * @param {*} payload
 */
function* GetPanelCategory({ payload, type }: PanelCategoryData): SagaIterator {
    try {
        const response = yield call(getPanelCategoryApi, payload);
        const { data, message, success, code } = response.data;

        if (code === 200 && success) {
            yield put(
                panelCategoryApiResponseSuccess(
                    PanelCategoryActionTypes.GET_PANEL_CATEGORY,
                    data,
                    message,
                    code,
                    false,
                    false
                )
            );
        } else {
            let msg = `An error while loading Panel Category!`;
            if (message) msg = message;
            yield put(
                panelCategoryApiResponseSuccess(
                    PanelCategoryActionTypes.GET_PANEL_CATEGORY,
                    data,
                    msg,
                    code,
                    true,
                    false
                )
            );
        }
    } catch (error: any) {
        yield put(
            panelCategoryApiResponseError(PanelCategoryActionTypes.GET_PANEL_CATEGORY, [], error, 404, true, false)
        );
    }
}

/**
 * Fetch Panel Categories
 * @param {*} payload
 */
function* GetPanelCategories({ payload, type }: PanelCategoryData): SagaIterator {
    try {
        const response = yield call(getAllPanelCategoryApi, payload);
        const { data, message, success, code } = response.data;

        const responseData = typeof data === 'object' && Object.keys(data).length === 0 ? [] : data;
        if (code === 200 && success) {
            yield put(
                panelCategoryApiResponseSuccess(
                    PanelCategoryActionTypes.GET_PANEL_CATEGORIES,
                    responseData,
                    message,
                    code,
                    false,
                    false
                )
            );
        } else {
            let msg = `An error while loading Panel Categories!`;
            if (message) msg = message;
            yield put(
                panelCategoryApiResponseSuccess(
                    PanelCategoryActionTypes.GET_PANEL_CATEGORIES,
                    responseData,
                    msg,
                    code,
                    true,
                    false
                )
            );
        }
    } catch (error: any) {
        yield put(
            panelCategoryApiResponseError(PanelCategoryActionTypes.GET_PANEL_CATEGORIES, [], error, 404, true, false)
        );
    }
}

export function* watchGetPanelCategory() {
    yield takeEvery(PanelCategoryActionTypes.GET_PANEL_CATEGORY, GetPanelCategory);
}

export function* watchAddPanelCategory() {
    yield takeEvery(PanelCategoryActionTypes.ADD_PANEL_CATEGORY, AddPanelCategory);
}

export function* watchEditPanelCategory(): any {
    yield takeEvery(PanelCategoryActionTypes.EDIT_PANEL_CATEGORY, EditPanelCategory);
}

export function* watchGetPanelCategories(): any {
    yield takeEvery(PanelCategoryActionTypes.GET_PANEL_CATEGORIES, GetPanelCategories);
}

function* panelCategorySaga() {
    yield all([
        fork(watchGetPanelCategory),
        fork(watchGetPanelCategories),
        fork(watchAddPanelCategory),
        fork(watchEditPanelCategory),
    ]);
}

export default panelCategorySaga;
